<template>
<b-container :id="content.id" class="section" :class="content.bgClass" fluid>
  <div class="section-top-padding"></div>
  <b-row>
    <!-- Begin text column -->
    <b-col 
      cols="12" 
      md="5"
      class="m-auto"
      order="1"
      :order-md="content.colOrderText"
    >
      <div class="px-3 pt-5 pb-0 p-md-5">
        <div class="d-flex mx-auto mb-2">
          <b-img 
            :src="require('../assets/' + content.eyebrowIcon)" 
            class="eyebrow-icon mr-3"
            v-if="content.eyebrowIcon"
          />
          <p class="my-auto eyebrow-subtitle" :class="btnLinkClass">
            {{ content.eyebrow }}
          </p>
        </div>
        <div>
          <div class="section-headline">
            <b-img 
              :src="require('../assets/' + content.headlineIcon)" 
              class="headline-icon mr-3"
              v-if="content.headlineIcon"
            />
            <h1 class="mb-4" v-if="!content.headlineLink">{{ content.headline }}</h1>
            <b-link :to="content.learnMoreLink" 
              :class="btnLinkClass"
              style="text-decoration: none;"
              @click.native="scrollToTop"
              v-if="content.headlineLink"
              >
              <h1 class="mb-4">{{ content.headline }}</h1>
            </b-link>
          </div>
          <!--p class="lead">{{ content.paragraphs[0] }}</p>
          <p class="lead">{{ content.paragraphs[1] }}</p>
          <p class="lead">{{ content.paragraphs[2] }}</p-->
          <p class="lead" v-for="paragraph in content.paragraphs" :key="paragraph">{{ paragraph }}</p>
        </div>
        <div v-html="content.html" v-if="content.html" />
        <b-button 
          variant="link" 
          size="lg"
          :class="btnLinkClass"
          class="font-weight-bold"
          style="text-decoration: none; padding-left: 0px !important;"
          :to="content.learnMoreLink"
          v-if="content.learnMoreLink"
          @click.native="scrollToTop"
        >
          Learn More 
          <font-awesome-icon :icon="faArrowRight" />
        </b-button>

        <!-- **BEGIN UNIQUE BUTTONS** -->
        <problems-buttons  v-if="uniqueContent === 'problemsButtons'" />
        <!-- ***END UNIQUE BUTTONS*** -->

      </div>
    </b-col>
    <!-- End text column -->
    <!-- Begin image column -->
    <b-col 
      cols="12"
      md="7"
      class="m-auto"
      order="2"
      :order-md="content.colOrderImage"
      v-if="content.image"
    >
      <div class="d-flex p-3 pb-5">
        <b-img 
          :src="require('../assets/' + content.image)" 
          :alt="content.imageAlt"
          fluid
          class="mx-auto"
          style="max-height: 590px;" 
        />
      </div>
    </b-col>
    <!-- End image column -->
    <!-- Begin video column -->
    <b-col 
      cols="12"
      md="7"
      class="m-auto"
      order="2"
      :order-md="content.colOrderImage"
      v-if="content.videoId"
    >
      <div id="vimeo-wrapper-landscape-desktop" class="p-3 pb-5 p-md-0" v-if="!videoHeightOverride">
        <vimeo-player
        class="mx-auto"
          :video-id="content.videoId"
          :options="{ 
            responsive: true,
          }"
        />
      </div>
      <div id="vimeo-wrapper-portrait-desktop" class="p-3 pb-5 p-md-0" v-if="videoHeightOverride && windowWidth > 575">
        <vimeo-player
          :video-id="content.videoId"
          :options="{ 
            responsive: false,
          }"
          :player-height="videoHeightValue"
        />
      </div>
      <div id="vimeo-wrapper-portrait-mobile" class="p-3 pb-5 p-md-0" v-if="videoHeightOverride && windowWidth < 576">
        <vimeo-player
          :video-id="content.videoId"
          :options="{ 
            responsive: true,
          }"
        />
      </div>
    </b-col>
    <!-- End video column -->
  </b-row>
</b-container>
</template>

<script>
import { vueWindowSizeMixin } from "vue-window-size";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import ProblemsButtons from './problems-buttons.vue';
export default {
  name: "Section",
  props: {
    content: Object,
    learnMoreOverride: Boolean,
    videoHeightOverride: Boolean,
    uniqueContent: String,
  },
  components: {
    FontAwesomeIcon,
    ProblemsButtons
  },
  data() {
    return {
      faArrowRight
    }
  },
  mixins: [vueWindowSizeMixin],
  computed: {
    btnLinkClass() {
      switch(this.content.bgClass) {
        case ('bg-neon-blue'):
          return 'text-light';
          break;
        case ('bg-neon-blue-grad'):
          return 'text-light';
          break;
        default:
          return 'text-dark';
      }
    },
    videoHeightValue() {
      var navbarHeight = 62;
      var padding = 96;
      if (this.windowWidth > 575) {
        return this.windowHeight - navbarHeight - padding;
      }
    }
  },
  methods: {
		scrollToTop: function () {
			window.scrollTo(0,0);
		},
	}
}
</script>

<style scoped>
.eyebrow-icon {
  height: 36px;
}
.section-headline {
  display: flex;
}
.headline-icon {
  height: 48px;
}
@media (max-width: 576px) {
  h1 {
    font-size: 2rem;
  }
}
</style>